import React from "react";
import { Button, DatePicker, Input, Select, Typography } from "antd";
import { OPTIMISATION_STATUS_OPTIONS, PRIORITY_OPTIONS } from "./utils";

const { Text } = Typography;
const { TextArea } = Input;

function OptimisationWorkflowForm({
  hasCalculated,
  formState,
  setFormState,
  assignToOptions,
  disabled,
  handleStatusChange,
  handleSaveAssignment,
  handleClearAssignment,
  handleSaveJustification,
  handleClearJustification,
}) {
  if (!hasCalculated) return null;

  return (
    <>
      <div className="optimisation-review__split-cards">
        <section className="optimisation-review__section optimisation-review__card">
          <div className="optimisation-review__section-head">
            <Text strong>Optimization Status</Text>
          </div>
          <label className="optimisation-review__field-label">Status</label>
          <Select
            disabled={disabled}
            className="optimisation-review__select"
            value={formState.optimisationStatus}
            options={OPTIMISATION_STATUS_OPTIONS}
            onChange={handleStatusChange}
          />
        </section>

        <section className="optimisation-review__section optimisation-review__card">
          <div className="optimisation-review__section-head">
            <Text strong>Assignment</Text>
          </div>
          <div className="optimisation-review__assignment-grid">
            <div>
              <label className="optimisation-review__field-label">
                Assign To
              </label>
              <Select
                disabled={disabled}
                className="optimisation-review__select"
                placeholder="Select user"
                allowClear
                value={formState.assignTo}
                options={assignToOptions}
                onChange={(value) =>
                  setFormState((prev) => ({
                    ...prev,
                    assignTo: value,
                  }))
                }
              />
            </div>
            <div>
              <label className="optimisation-review__field-label">
                Due Date
              </label>
              <DatePicker
                disabled={disabled}
                className="optimisation-review__datepicker"
                format="DD-MM-YYYY"
                placeholder="dd-mm-yyyy"
                value={formState.dueDate}
                onChange={(value) =>
                  setFormState((prev) => ({
                    ...prev,
                    dueDate: value,
                  }))
                }
              />
            </div>
            <div>
              <label className="optimisation-review__field-label">
                Priority
              </label>
              <Select
                disabled={disabled}
                className="optimisation-review__select"
                value={formState.priority}
                options={PRIORITY_OPTIONS}
                onChange={(value) =>
                  setFormState((prev) => ({
                    ...prev,
                    priority: value,
                  }))
                }
              />
            </div>
          </div>
          <div className="optimisation-review__assignment-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
            <Button
              size="small"
              onClick={handleClearAssignment}
              disabled={disabled}
            >
              Clear
            </Button>
            <Button
              type="primary"
              size="small"
              onClick={handleSaveAssignment}
              disabled={disabled}
            >
              Save
            </Button>
          </div>
        </section>
      </div>

      <section className="optimisation-review__section optimisation-review__card">
        <div className="optimisation-review__section-head">
          <Text strong>Business Justification</Text>
        </div>
        <TextArea
          disabled={disabled}
          className="optimisation-review__justification"
          rows={4}
          placeholder="Explain why the inspection interval should be changed..."
          value={formState.justification}
          onChange={(event) =>
            setFormState((prev) => ({
              ...prev,
              justification: event.target.value,
            }))
          }
        />
        <div className="optimisation-review__notes-grid">
          <div className="optimisation-review__note-field">
            <label>Engineering Observations</label>
            <TextArea
              disabled={disabled}
              rows={4}
              value={formState.engineeringObservations}
              onChange={(event) =>
                setFormState((prev) => ({
                  ...prev,
                  engineeringObservations: event.target.value,
                }))
              }
            />
          </div>
          <div className="optimisation-review__note-field">
            <label>Maintenance Considerations</label>
            <TextArea
              disabled={disabled}
              rows={4}
              value={formState.maintenanceConsiderations}
              onChange={(event) =>
                setFormState((prev) => ({
                  ...prev,
                  maintenanceConsiderations: event.target.value,
                }))
              }
            />
          </div>
          <div className="optimisation-review__note-field">
            <label>Supporting Notes</label>
            <TextArea
              disabled={disabled}
              rows={4}
              value={formState.supportingNotes}
              onChange={(event) =>
                setFormState((prev) => ({
                  ...prev,
                  supportingNotes: event.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="optimisation-review__justification-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
          <Button
            size="small"
            onClick={handleClearJustification}
            disabled={disabled}
          >
            Clear
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={handleSaveJustification}
            disabled={disabled}
          >
            Save
          </Button>
        </div>
      </section>
    </>
  );
}

export default React.memo(OptimisationWorkflowForm);
